module.exports = __webpack_public_path__ + "static/media/los-angeles.3ea4882c.jpg";